import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getProductReviews, postUpDownVote, postInappropriateFlag } from 'features/productReviews/api';

const reducerName = 'productReviews';
const initialState = {
	reviews: [],
	fetchStatus: '',
	previousPageNumber: 1,
	pageNumber: 1,
	sortOrder: 2,
	reviewFilters: [],
	totalReviews: 0,
	reviewsSummary: {}
};
const fetchProductReviews = createAsyncThunk(
	reducerName,
	async (apiParams) => {

		const response = await getProductReviews({ ...apiParams });

		return response;

	},
	{
		condition: (arg, { getState }) => {

			const { productReviews } = getState();
			const { fetchStatus } = productReviews;
			if (fetchStatus === 'pending') {

				return false;

			}
			return true;

		}
	}
);

const updateUpDownVote = createAsyncThunk(`${reducerName}/UpDownVote`, async (data) => {

	const response = await postUpDownVote(data.id, data.voteType);

	return response;

});

const updateInappropriateFlag = createAsyncThunk(`${reducerName}/updateInappropriateFlag`, async (id) => {

	const response = await postInappropriateFlag(id);

	return response;

});
const productReviewsSlice = createSlice({
	name: reducerName,
	initialState,
	reducers: {
		// put reducers here
		loadMoreReviews (state) {

			state.pageNumber += 1;

		},
		updateSortOrder (state, action) {

			state.sortOrder = action.payload;
			state.previousPageNumber = 1;
			state.pageNumber = 1;

		},
		applyFilter (state, action) {

			const newFilter = action.payload;
			state.reviewFilters.push(newFilter);
			state.previousPageNumber = 1;
			state.pageNumber = 1;

		},
		removeFilter (state, action) {

			const filterToRemove = action.payload;
			const removeIndex = state.reviewFilters.findIndex((f) => f.value === filterToRemove.value);
			if (removeIndex > -1) {

				state.reviewFilters = [
					...state.reviewFilters.slice(0, removeIndex),
					...state.reviewFilters.slice(removeIndex + 1)
				];

			}
			state.previousPageNumber = 1;
			state.pageNumber = 1;

		},
		resetState: (state, action) => {

			const { reviewsData, reviewsSummaryData } = action.payload;

			const reviews = reviewsData?.results || [];
			return {
				reviews,
				fetchStatus: 'fulfilled',
				previousPageNumber: 1,
				pageNumber: 1,
				sortOrder: 2,
				reviewFilters: [],
				totalReviews: reviewsData?.totalRecords || 0,
				reviewsSummary: reviewsSummaryData
			};

		}
	},
	extraReducers: {
		[fetchProductReviews.pending]: (state) => {

			state.fetchStatus = 'pending';

		},
		[fetchProductReviews.fulfilled]: (state, action) => {

			const { pageNumber } = state;
			const { payload } = action;
			const { results, totalRecords } = payload.result;

			// when loading more reviews we want to append to reviews list
			if (state.previousPageNumber < pageNumber) {

				state.previousPageNumber = pageNumber;
				state.reviews.push(...results);

			} else {

				// otherwise we overwrite reviews list
				state.reviews = results;
				state.totalReviews = totalRecords;

			}
			state.fetchStatus = 'fulfilled';

		},
		[fetchProductReviews.rejected]: (state, action) => {

			state.fetchProductReviewsError = action.payload;
			state.fetchStatus = 'rejected';

		},
		[updateUpDownVote.pending]: (state, action) => {

			// optimistically update state
			const { id, voteType } = action.meta.arg;
			const { reviews } = state;
			const review = reviews.find((rev) => rev.id === id);

			if (review) {

				switch (voteType) {

					case 'voteup':
						review.upVotes += 1;
						break;
					case 'votedown':
						review.downVotes += 1;
						break;
					default:
						break;

				}

			}

		},
		[updateUpDownVote.rejected]: (state, action) => {

			// revert state if update fails.
			const { id, voteType } = action.meta.arg;
			const { reviews } = state;
			const review = reviews.find((rev) => rev.id === id);

			if (review) {

				switch (voteType) {

					case 'voteup':
						review.upVotes += 1;
						break;
					case 'votedown':
						review.downVotes -= 1;
						break;
					default:
						break;

				}

			}

		},
		[updateInappropriateFlag.fulfilled]: (state, action) => {

			const { id } = action.meta.arg;
			const { reviews } = state;
			const review = reviews.find((rev) => rev.id === id);

			if (review) {

				review.inappropriateFlag = true;

			}

		}
	}
});

const {
	loadMoreReviews, updateSortOrder, applyFilter, removeFilter, resetState
} = productReviewsSlice.actions;

export {
	fetchProductReviews,
	loadMoreReviews,
	updateSortOrder,
	updateUpDownVote,
	updateInappropriateFlag,
	applyFilter,
	removeFilter,
	resetState
};
export default productReviewsSlice.reducer;
